export class GridColumn {
  dataField?: string;
  visible?: boolean;
  caption?: string;
  type?: string;
  template?: string;
  mode?: string;
  sortable?: boolean;
  sortDirection?: string;
  width?: any;
  minWidth?: number;
  widthCoefficient?: number;
  description?: string;

  constructor(
    dataField?: string,
    visible?: boolean,
    caption?: string,
    type?: string,
    template?: string,
    mode?: string,
    sortable?: boolean,
    width?: any,
    minWidth?: number,
    widthCoefficient?: number,
    description?: string
  ) {
    this.dataField = dataField;
    this.visible = visible;
    this.caption = caption;
    this.type = type;
    this.template = template;
    this.mode = mode;
    this.sortable = sortable;
    this.sortDirection = 'asc';
    this.width = width;
    this.minWidth = minWidth;
    this.widthCoefficient = widthCoefficient;
    this.description = description;
  }
}

export class GridColumns {
  [id: string]: GridColumn;
}

export const GRID_COLUMNS_ORDER = [
  // General
  "checkbox",
  "symbol",
  "companyname",
  "exchange",
  "quotetime",

  // Stock Price
  "last",
  "open",
  "high",
  "low",
  "change",
  "changepercent",
  "changeopen",
  "changepercentopen",
  "stockvolume",
  "cumulativeprice_eod",
  "cumulativevalue_eod",
  "vwap",
  "bid",
  "bidsize",
  "asksize",
  "ask",
  "close_eod",
  "change_eod",
  "changepercent_eod",
  "stockvolume_eod",
  "vwap_eod",
  "ask_eod",
  "pcasize_eod",
  "bid_eod",
  "pcbsize_eod",
  "highdate52wk_eod",
  "highprice52wk_eod",
  "lowdate52wk_eod",
  "lowprice52wk_eod",

  // Implied Volatility
  "ivx30hv20_eod",
  "callputivxratio",
  "ivx7",
  "ivx7chg",
  "ivx7chgpercent",
  "ivx7chgopen",
  "ivx7chgpercentopen",
  "ivx14",
  "ivx14chg",
  "ivx14chgpercent",
  "ivx14chgopen",
  "ivx14chgpercentopen",
  "ivx21",
  "ivx21chg",
  "ivx21chgpercent",
  "ivx21chgopen",
  "ivx21chgpercentopen",
  "ivx30",
  "ivx30chg",
  "ivx30chgpercent",
  "ivx30chgopen",
  "ivx30chgpercentopen",
  "ivp30_eod",
  "ivr30_eod",
  "ivx30_eod",
  "ivx30chg_eod",
  "ivx30chgpercent_eod",
  "ivx30highlow",
  "ivx30highlowdate",
  "ivx60",
  "ivx60chg",
  "ivx60chgpercent",
  "ivx60chgopen",
  "ivx60chgpercentopen",
  "ivp60_eod",
  "ivr60_eod",
  "ivx60_eod",
  "ivx60chg_eod",
  "ivx60chgpercent_eod",
  "ivx60highlow",
  "ivx60highlowdate",
  "ivx90",
  "ivx90chg",
  "ivx90chgpercent",
  "ivx90chgopen",
  "ivx90chgpercentopen",
  "ivp90_eod",
  "ivr90_eod",
  "ivx90_eod",
  "ivx90chg_eod",
  "ivx90chgpercent_eod",
  "ivx90highlow",
  "ivx90highlowdate",
  "ivx120",
  "ivx120chg",
  "ivx120chgpercent",
  "ivx120chgopen",
  "ivx120chgpercentopen",
  "ivp120_eod",
  "ivr120_eod",
  "ivx120_eod",
  "ivx120chg_eod",
  "ivx120chgpercent_eod",
  "ivx120highlow",
  "ivx120highlowdate",
  "ivx150",
  "ivx150chg",
  "ivx150chgpercent",
  "ivx150chgopen",
  "ivx150chgpercentopen",
  "ivp150_eod",
  "ivr150_eod",
  "ivx150_eod",
  "ivx150chg_eod",
  "ivx150chgpercent_eod",
  "ivx150highlow",
  "ivx150highlowdate",
  "ivx180",
  "ivx180chg",
  "ivx180chgpercent",
  "ivx180chgopen",
  "ivx180chgpercentopen",
  "ivp180_eod",
  "ivr180_eod",
  "ivx180_eod",
  "ivx180chg_eod",
  "ivx180chgpercent_eod",
  "ivx180highlow",
  "ivx180highlowdate",
  "ivx270",
  "ivx270chg",
  "ivx270chgpercent",
  "ivx270chgopen",
  "ivx270chgpercentopen",
  "ivx360",
  "ivx360chg",
  "ivx360chgpercent",
  "ivx360chgopen",
  "ivx360chgpercentopen",
  "ivx720",
  "ivx720chg",
  "ivx720chgpercent",
  "ivx720chgopen",
  "ivx720chgpercentopen",
  "ivx1080",
  "ivx1080chg",
  "ivx1080chgpercent",
  "ivx1080chgopen",
  "ivx1080chgpercentopen",
  "d10_eod",
  "d25_eod",

  //Historical Volatility
  "hv10_eod",
  "hvp10_eod",
  "hv20_eod",
  "hvp20_eod",
  "hv30_eod",
  "hvp30_eod",
  "hv30hl_eod",
  "hv60_eod",
  "hvp60_eod",
  "hv60hl_eod",
  "hv90_eod",
  "hvp90_eod",
  "hv90hl_eod",
  "hv120_eod",
  "hvp120_eod",
  "hv120hl_eod",
  "hv150_eod",
  "hvp150_eod",
  "hv150hl_eod",
  "hv180_eod",
  "hvp180_eod",
  "hv180hl_eod",

  // Options
  "optvol",
  "optvolcall",
  "optvolput",
  "callputvolumeratio",
  "putcallvolumeratio",
  "optvol_eod",
  "optvolcall_eod",
  "optvolput_eod",
  "callputvolumeratio_eod",
  "putcallvolumeratio_eod",
  "openinterest_eod",
  "openinterestcall_eod",
  "openinterestput_eod",
  "avgoptoi1wk_eod",
  "avgoptvol1wk_eod",
  "avgoptoi1mo_eod",
  "avgoptvol1mo_eod",

  // Fundamental
  "industry",
  "marketcap_eod",
  "dividendamount_eod",
  "dividenddate_eod",
  "dividendfrequency_eod",
  "dividendyield_eod",
  "outstandingshares_eod",
  "eps_eod",
  "pe_eod",

  // Correlations
  "correlation10d_eod",
  "correlation20d_eod",
  "correlation30d_eod",
  "correlation60d_eod",
  "correlation90d_eod",
  "correlation120d_eod",
  "correlation150d_eod",
  "correlation180d_eod",

  // Beta
  "beta10d_eod",
  "beta20d_eod",
  "beta30d_eod",
  "beta60d_eod",
  "beta90d_eod",
  "beta120d_eod",
  "beta150d_eod",
  "beta180d_eod",
]
